module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pb-0",
    attrs: {
      "dark": "",
      "flat": "",
      "height": "100%"
    }
  }, [_c('v-list', {
    staticClass: "black pa-0"
  }, [_c('v-list-tile', {
    on: {
      "click": _vm.launchDateRangePicker
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(_vm.params.after) + " - " + _vm._s(_vm.params.before) + "\n        ")]), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.invoiceableClients) ? _c('span', [_vm._v(_vm._s(_vm.invoiceableClients.count))]) : _vm._e(), _vm._v("\n          Clients with appointments\n        ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("event")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-0 pl-0 black lighten-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('status-picker', {
    model: {
      value: (_vm.selectedStatuses),
      callback: function($$v) {
        _vm.selectedStatuses = $$v
      },
      expression: "selectedStatuses"
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.request
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "mb-0 pb-0"
  }, [_vm._l((_vm.invoiceableClients), function(client, index) {
    return [_c('v-list-tile', {
      key: index,
      class: {
        'grey darken-4': (client.id === _vm.selectedClientId)
      },
      on: {
        "click": function($event) {
          return _vm.clientClicked(client)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "mb-1"
    }, [_vm._v("\n                " + _vm._s(client.first_name) + " " + _vm._s(client.last_name) + "\n              ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                " + _vm._s(client.count) + " " + _vm._s(_vm.$tc('list.appointments', client.count, {
      count: client.count
    })) + "\n              ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', [_vm._v(_vm._s(_vm.$t('btn.createInvoice')))])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("d-" + index)
    })]
  }), _vm._v(" "), (_vm.invoiceableClients.length === 0 && !_vm.request.loading) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('page.noresults')))])], 1)], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd40c778","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/Invoiceable/InvoiceableClientList.vue
// module id = 1537
// module chunks = 9